// extracted by mini-css-extract-plugin
export default {"select":"PaginationLimit_select__NXtUd"};